import { TRIGGER_EVENTS_FROM_FE_INSTEAD_OF_BE_241126 } from "@faire/web-api--source/indigofair/settings/TRIGGER_EVENTS_FROM_FE_INSTEAD_OF_BE_241126";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingFeEvents = (): boolean => {
  return useSetting(TRIGGER_EVENTS_FROM_FE_INSTEAD_OF_BE_241126, false);
};
